const handoffHeaders = {
  "Content-Type": "application/json",
  "X-Workl-Auth-Handoff": "1"
}

export default async function setSessionCookies(session) {
  const response = await fetch("/api/auth/session-handoff", {
    body: JSON.stringify({
      accessToken: session.getAccessToken().getJwtToken(),
      idToken: session.getIdToken().getJwtToken(),
      refreshToken: session.getRefreshToken().getToken()
    }),
    credentials: "include",
    headers: handoffHeaders,
    method: "POST"
  })

  if (!response.ok) throw new Error("Unable to establish the server session.")

  await getSession()
}

export async function getSession() {
  const response = await fetch("/api/auth/session", {
    credentials: "include",
    method: "GET"
  })

  if (!response.ok) throw new Error("Unable to verify the server session.")

  const session = await response.json().catch(() => null)
  if (session?.authenticated !== true || typeof session.userId !== "string") {
    throw new Error("Unable to verify the server session.")
  }

  return session
}

export async function clearSessionCookies() {
  const response = await fetch("/api/auth/logout", {
    credentials: "include",
    headers: { "X-Workl-Auth-Handoff": "1" },
    method: "POST"
  })

  if (!response.ok) throw new Error("Unable to clear the server session.")
}
